import {
  numberToCurrencyString,
  numberToDisplayString,
} from 'further-ui/utils';
import { CurrencyCode } from 'further-types/lp/vehicle';
import SectionedTable, { Row } from 'components/SectionedTable';
import { Box, styled } from '@mui/material';
import useFormatHoldingClassData from './useFormatHoldingClassData';
import { CONSIDERATION_ROWS } from './constants';
import { ConsiderationType, HoldingClassRealisations } from '../../types';

const TableContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

type Props = {
  holdingClassRealisations: HoldingClassRealisations;
  currency: CurrencyCode;
};

const PerClassAllocationTable: React.FC<Props> = ({
  holdingClassRealisations,
  currency,
}) => {
  const formattedHoldingClassRealisations = useFormatHoldingClassData(
    holdingClassRealisations,
  );

  const columns = [
    {
      key: 'label',
      label: 'Unit class',
    },
    ...formattedHoldingClassRealisations.map(
      ({ holdingClassId, holdingClassName }, colIdx) => ({
        key: holdingClassId,
        label: holdingClassName,
        render: (row: Row) => {
          const value = formattedHoldingClassRealisations[colIdx][row.key];
          const formattedValue =
            row.key === ConsiderationType.UnitsRealised
              ? numberToDisplayString(value)
              : numberToCurrencyString(value, { currency, unlimitedDp: true });
          return formattedValue;
        },
      }),
    ),
  ];

  return (
    <TableContainer>
      <SectionedTable
        columns={columns}
        rows={CONSIDERATION_ROWS}
        headerColor="grey"
        hasGroupPadding={false}
      />
    </TableContainer>
  );
};

export default PerClassAllocationTable;
